import { EDays, EReccurenceType, EVehiculeType, Request } from "generated/graphql";
import { MotorCycleIcon, TreeCycleIcon, TruckIcon, VanIcon, VanXlIcon } from "icons";
import moment from "moment";
import React from "react";
import { truncateMessage } from "utils";
import { getRecurrenceMonthOptions } from "./utils";

export const formatDate = (value: string) => {
  if (!value) {
    return "";
  }
  const date = moment(value);
  return date.isValid() ? date.format("DD/MM/YYYY") : "";
};

export const renderReccurenceWeeksOptionsDay = (requestQuote: Request, text: any) =>
  requestQuote?.reccurenceOptions?.days?.map((day) => {
    switch (day) {
      case EDays.Monday:
        return `${text.requestQuote.reccurence_day_option_monday}, `;
      case EDays.Tuesday:
        return `${text.requestQuote.reccurence_day_option_tuesday}, `;
      case EDays.Wednesday:
        return `${text.requestQuote.reccurence_day_option_wednesday}, `;
      case EDays.Thursday:
        return `${text.requestQuote.reccurence_day_option_thursday}, `;
      case EDays.Friday:
        return `${text.requestQuote.reccurence_day_option_friday}, `;
      case EDays.Saturday:
        return `${text.requestQuote.reccurence_day_option_saturday}, `;

      default:
        break;
    }
  });

export const renderReccurenceWeeksOptionMonth = (startDate: string, requestQuoteMonthValue: any, text: any) => {
  const options = getRecurrenceMonthOptions(startDate);
  return options.find((o) => o.value === requestQuoteMonthValue)?.description(text) || "N/A";
};

export const renderReccurenceOption = (requestQuote: Request, text: any, isForCard = false) => {
  switch (requestQuote?.reccurenceType) {
    case EReccurenceType.DoesNotRepeat:
      return text.requestQuote.reccurence_not_repeat;
    case EReccurenceType.Everyday:
      return (
        <>
          {isForCard ? (
            <>
              {`${text.requestQuote.reccurence_daily_card} `}
              <b>{text.all.until}</b> ...
            </>
          ) : (
            <>
              {`${text.requestQuote.reccurence_daily} `}
              <b>{text.all.until}</b> {formatDate(requestQuote?.endDate)}
            </>
          )}
        </>
      );
    case EReccurenceType.Days:
      return (
        <>
          {`${text.requestQuote.reccurence_each} ${requestQuote?.reccurenceOptions?.each} 
          ${text.requestQuote.reccurence_type_days} `}
          <b>{`${text.all.until} `}</b>
          {formatDate(requestQuote?.endDate)}
        </>
      );
    case EReccurenceType.Weeks:
      return (
        <>
          {isForCard ? (
            <>
              {`${text.requestQuote.reccurence_each} ${requestQuote?.reccurenceOptions?.each} 
          ${text.requestQuote.reccurence_type_weeks} ${text.requestQuote.reccurence_on} ...`}
            </>
          ) : (
            <>
              {`${text.requestQuote.reccurence_each} ${requestQuote?.reccurenceOptions?.each} 
          ${text.requestQuote.reccurence_type_weeks} ${text.requestQuote.reccurence_on} 
          ${renderReccurenceWeeksOptionsDay(requestQuote, text)} `}
              <b>{`${text.all.until} `}</b>
              {formatDate(requestQuote?.endDate)}
            </>
          )}
        </>
      );
    case EReccurenceType.Months:
      return (
        <>
          {isForCard ? (
            <>
              {`${text.requestQuote.reccurence_each} 
              ${requestQuote?.reccurenceOptions?.each} 
              ${text.requestQuote.reccurence_type_months} `}
              {truncateMessage(
                renderReccurenceWeeksOptionMonth(requestQuote?.startDate, requestQuote?.reccurenceOptions?.value, text),
                15
              )}
            </>
          ) : (
            <>
              {text.requestQuote.reccurence_each} {requestQuote?.reccurenceOptions?.each}{" "}
              {text.requestQuote.reccurence_type_months}{" "}
              {renderReccurenceWeeksOptionMonth(requestQuote?.startDate, requestQuote?.reccurenceOptions?.value, text)}{" "}
              <b>{text.all.until}</b> {formatDate(requestQuote?.endDate)}
            </>
          )}
        </>
      );
    case EReccurenceType.Years:
      return (
        <>
          {text.requestQuote.reccurence_each} {requestQuote?.reccurenceOptions?.each}{" "}
          {text.requestQuote.reccurence_type_year} <b>{text.all.until}</b> {formatDate(requestQuote?.endDate)}
        </>
      );
    default:
      return "N/A";
  }
};

export const renderIconRequest = (vehicle: EVehiculeType, color: string = "#399ebf", width = 24) => {
  switch (vehicle) {
    case EVehiculeType.Scooter:
      return <MotorCycleIcon color={color} width={width} />;
    case EVehiculeType.MiniVan:
      return <VanIcon color={color} width={width} />;
    case EVehiculeType.Van:
      return <VanXlIcon color={color} width={width} />;
    case EVehiculeType.Tricycle:
      return <TreeCycleIcon color={color} width={width} />;
    default:
      return <TruckIcon color={color} width={width} />;
  }
};
